<script lang="ts" setup>
import { ArrowRightOnRectangleIcon } from '@heroicons/vue/24/outline';
import { router, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import type { User } from 'types';
import { route } from '../composables/routes';

type ImpersonationPageProps = {
    impersonating: {
        impersonator: User;
        impersonated_user: User;
    } | null;
};

const page = usePage<ImpersonationPageProps>();

const impersonating = computed(() => page.props.impersonating);

function leaveImpersonation() {
    router.post(route('leave-impersonation'), {}, {
        preserveScroll: false,
    });
}
</script>

<template>
    <div
        v-if="impersonating"
        class="w-full bg-rose-500 text-white antialiased dark:bg-rose-600">
        <div class="mx-auto flex h-12 items-center justify-between gap-4 px-5 md:px-8">
            <div class="flex min-w-0 items-center gap-3">
                <span
                    class="relative flex h-2 w-2 shrink-0"
                    aria-hidden="true">
                    <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-70" />
                    <span class="relative inline-flex h-2 w-2 rounded-full bg-white" />
                </span>
                <span class="text-sm font-semibold leading-none text-white">
                    Impersonating
                </span>
                <span class="truncate text-sm leading-none text-white/90">
                    {{ impersonating.impersonated_user.email }}
                </span>
            </div>
            <button
                type="button"
                class="btn btn-white btn-xs shrink-0"
                @click="leaveImpersonation">
                <ArrowRightOnRectangleIcon class="h-4 w-4" />
                Exit
            </button>
        </div>
    </div>
</template>
